export default "__VITE_ASSET__BJooJQPh__";